const Forecast = ({ forecast, unit }) => {
  if (!forecast) return null;

  return (
    <div className="forecast">
      {forecast.daily.map((day, index) => (
        <div key={index} className="forecast-card">
          <p>
            {new Date(day.time * 1000).toLocaleDateString(undefined, {
              weekday: "short",
            })}
          </p>

          <img src={day.condition.icon_url} alt="" />

          <p>{Math.round(day.temperature.day)}°C</p>
        </div>
      ))}
    </div>
  );
};
export default Forecast;
